export const _404Page = () => {
  return (
    <div className={'mt-[38px] w-[1450px] flex flex-col items-center mx-auto'}>
      <h1>Еще в разработке :)</h1>
    </div>
  );
};
